<template lang="pug">
#home-for-other-office-service.mb-0
  //- other office information
  .row.other-office-base-info(v-cloak)
    .box
      .box-header.d-flex.flex-row
        .note
          span 他事業所（病院・居宅介護支援事業所など）のアカウントと連携するとメッセージの送受信等が出来ます。
          br
          span アカウント招待には家族連絡サービスの有料プラン契約が必要です（招待を受ける事業所はアカウントが無くてもフリープランでも可能です）。
        .buttons.d-flex.flex-row.justify-content-end.flex-wrap.flex-fill
            button.btn.goto-list-btn.mr-2(@click="onGotoList") 招待状況
            button.btn.sned-mail-btn(v-if="_otherOfficeTopPageFunction && _isOverLightPlan && _useFamilyService" @click="onInvitation") 新規招待
      .box-body(style="padding-top:0;")
        OtherOfficeFacilitiesTable(v-model="items" :fields="fields" :totalRows.sync="rows"
          :currentPage.sync="currentPage" :perPage="perPage" :isLoading="isLoading" :filter="filter"
          @onDetail="onDetail" @onApplication="onApplication")
        .table-options.d-flex.flex-row.justify-content-end.align-items-center.flex-wrap
          //- 詳細検索表示／非表示切替え
          .flex-fill.mr-2
            button.btn.advanced-filters-btn(@click="showAdvancesFilesr =! showAdvancesFilesr") 
              span(v-show="!showAdvancesFilesr") 詳細検索を表示
              span(v-show="showAdvancesFilesr") 詳細検索を非表示
          //- ページあたりの行数
          span.table-option-text 1ページの行数:
          .per-page
            b-form-select(id="per-page-select" v-model="perPage" :options="pageOptions" size="md" @change="selectPerPage")
          //- ページネーション
          b-pagination.m-0(v-model="currentPage" :total-rows="rows" :per-page="perPage" :disabled="isLoading" @change="selectPage"
            hide-goto-end-buttons)

        //- 詳細検索
        .advanced-filters.table-options.d-flex.flex-row.align-items-center.flex-wrap.mt-2(v-if="showAdvancesFilesr")
          //- 概要検索
          .basic-filters.d-flex.flex-column.flex-wrap.p-2
            //- 地域コード
            .basic-filter
              .d-flex.flex-row.align-items-center
                span.table-option-text.font-weight-bold.text-nowrap 都道府県:
                b-form-select(id="filter-prefecture" v-model="filter.prefecture" :options="_prefectureOptions" size="sm" style="width: 120px; max-width: 120px;")
              .d-flex.flex-column.flex-wrap.mt-2(v-if="filter.prefecture")
                span.table-option-text.font-weight-bold.mb-2 市区町村:
                b-form-checkbox-group(v-model="filter.municipalities[filter.prefecture]")
                  b-form-checkbox.mr-4.mb-2(
                    v-for="municipality in _municipalities" :key="municipality.municipalityCode" :value="municipality.municipalityCode" size="sm") {{ municipality.name }}
            //- 施設種別
            .basic-filter
              .d-flex.flex-row.align-items-center
                span.table-option-text.font-weight-bold.text-nowrap 施設種別:
                b-form-select(id="filter-facility-category" v-model="filter.facilityCategory" :options="_facilityCategoryOptions" size="sm" style="width: 300px; max-width: 300px;")
            //- 介護度（複数選択可能）
            .basic-filter
              .d-flex.flex-column.flex-wrap
                span.table-option-text.font-weight-bold.mb-2 介護度:
                div
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel1000" inline) 自立
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel1010" inline) 申請中
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel2010" inline) 要支援１
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel2020" inline) 要支援２
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel3010" inline) 要介護１
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel3020" inline) 要介護２
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel3030" inline) 要介護３
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel3040" inline) 要介護４
                  b-form-checkbox.mr-4.mb-2(v-model="filter.careLevels.careLevel3050" inline) 要介護５
            //- 生活保護を受け入れるか否か
            .basic-filter
              .d-flex.flex-row.align-items-center.flex-wrap(style="min-height: 31px;")
                span.table-option-text.font-weight-bold.text-nowrap 生活保護:
                b-form-checkbox.mr-2.ml-2(v-model="filter.acceptsWelfare" inline) 受け入れ可 施設のみ
            //- 医療・看護体制
            .basic-filter
              .d-flex.flex-column.flex-wrap
                span.table-option-text.font-weight-bold.mb-2 医療・看護体制:
                div
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.nursingCareFood" inline) 介護食
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.liquidDysphagiaDiet" inline) 流動食・嚥下食
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.diabetesInsulin" inline) 糖尿病・インスリン
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.gastrostomy" inline) 胃ろう
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.nasogastricTube" inline) 鼻腔・経管栄養
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.stomaOrColostomy" inline) ストーマ・人工肛門
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.homeOxygenTherapy" inline) 在宅酸素療法
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.ventilator" inline) 人工呼吸器
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.bedsore" inline) 褥瘡・床ずれ
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.phlegmSuction" inline) たん吸引
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.dialysis" inline) 人工透析
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.tracheostomy" inline) 気管切開
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.totalParenteralNutrition" inline) 中心静脈栄養
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.urinaryCatheterOrBalloonCatheter" inline) カテーテル・尿バルーン
                  b-form-checkbox.mr-4.mb-2(v-model="filter.medicalNursings.pacemaker" inline) ペースメーカー
            //- 事業所名
            .basic-filter
              .d-flex.flex-row.align-items-center.flex-wrap(style="min-height: 31px;")
                span.table-option-text.font-weight-bold.text-nowrap 事業所名:
                b-form-input(id="filter-office-name" v-model="filter.officeName" size="sm" style="width: 300px; max-width: 300px;")

    //- 招待メールモーダル
    InvitationOtherOfficeModal(v-model="showInputInvitationModal" :items="items" @ok="inputedInvitation")
    OkCancelModal(v-model="showConfirmInvitationModal" title="招待メールを送信しますか？" @ok="sendInvitation")
    OkModal(v-model="showSendInvitationSuccessModal" title="招待メールを送信しました")

    //- loading modal
    PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore, regionsStore } from "@/store/store";

import Setting from "../../../public/setting.json";
import { PcUrl } from "@/commons/constants/PcUrl";

import OtherOfficeConnectionsService, { OtherOfficeConnectionGetModel, OtherOfficeConnectionMailPostModel, SenderType } from "@/commons/services/OtherOfficeConnections";
import { PlanType } from "@/commons/services/Plans";
import WaiterRecruitmentsService from "@/commons/services/WaiterRecruitments";

import OtherOfficeFacilitiesTable, { FilterSetting, OtherOfficeFacilitiesTableField, OtherOfficeFacilitiesTableItem } from "@/pc/containers/base/OtherOfficeFacilitiesTable.vue";
import InvitationOtherOfficeModal from "@/pc/containers/base/InvitationOtherOfficeModal.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import { FacilityCategory } from "@/commons/services/Facilities";
import { RegionMaster } from "@/commons/services/RegionMasters";

/**
 * ### 他事業所連携サービス ホーム画面
 */
@Component({
  components: {
    OtherOfficeFacilitiesTable,
    InvitationOtherOfficeModal,
    OkCancelModal,
    OkModal,
    PageLoading
  }
})
export default class HomeForFamiliesService extends Vue {
  /** 他事業所連携管理サービス */
  @Inject("OtherOfficeConnectionsService") otherOfficeConnectionsService!: OtherOfficeConnectionsService;
  /** 待機者募集ページ */
  @Inject("WaiterRecruitmentsService") waiterRecruitmentsService!: WaiterRecruitmentsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 招待メール入力モーダル表示可否 */
  showInputInvitationModal: boolean = false;
  /** 招待メール入力モーダルの入力結果 */
  invitationOtherOfficeConnection: { mailaddress: string; officeName: string; staffName: string } = {
    mailaddress: "",
    officeName: "",
    staffName: ""
  };
  /** 招待メール送信確認モーダル表示可否 */
  showConfirmInvitationModal: boolean = false;
  /** 招待メール送信完了モーダル表示可否 */
  showSendInvitationSuccessModal: boolean = false;

  /** テーブル読込み中 */
  isLoading: boolean = true;
  /** テーブル列 */
  fields: Array<OtherOfficeFacilitiesTableField> = [];
  /** テーブル行 */
  items: Array<OtherOfficeFacilitiesTableItem> = [];

  /** 詳細検索表示可否 */
  showAdvancesFilesr: boolean = false;
  /** フィルタリング条件 */
  filter: FilterSetting = {
    /** 地域（都道府県） */
    prefecture: "",
    /** 地域（市区町村） */
    municipalities: {} as { [key: string]: string[] }, // 市区町村の選択状態を管理
    /** 施設種別 */
    facilityCategory: "",
    /** 介護度（複数選択可能） */
    careLevels: {
      /** 自立 */
      careLevel1000: false,
      /** 申請中 */
      careLevel1010: false,
      /** 要支援１ */
      careLevel2010: false,
      /** 要支援２ */
      careLevel2020: false,
      /** 要介護1 */
      careLevel3010: false,
      /** 要介護2 */
      careLevel3020: false,
      /** 要介護3 */
      careLevel3030: false,
      /** 要介護4 */
      careLevel3040: false,
      /** 要介護5 */
      careLevel3050: false
    },
    /** 生活保護 */
    acceptsWelfare: false,
    /** 医療・介護体制 */
    medicalNursings: {
      /** 介護食 */
      nursingCareFood: false,
      /** 流動食・嚥下食 */
      liquidDysphagiaDiet: false,
      /** 糖尿病・インスリン */
      diabetesInsulin: false,
      /** 胃ろう */
      gastrostomy: false,
      /** 鼻腔・経管栄養 */
      nasogastricTube: false,
      /** ストーマ・人工肛門 */
      stomaOrColostomy: false,
      /** 在宅酸素療法 */
      homeOxygenTherapy: false,
      /** 人工呼吸器 */
      ventilator: false,
      /** 褥瘡・床ずれ */
      bedsore: false,
      /** たん吸引 */
      phlegmSuction: false,
      /** 人工透析 */
      dialysis: false,
      /** 気管切開 */
      tracheostomy: false,
      /** 中心静脈栄養 */
      totalParenteralNutrition: false,
      /** カテーテル・尿バルーン */
      urinaryCatheterOrBalloonCatheter: false,
      /** ペースメーカー */
      pacemaker: false
    },
    /** 事業所名 */
    officeName: ""
  };

  /** ページングの現在ページ番号 */
  currentPage: number = 1;
  /** ページングの全体行数 */
  rows: number = 0;
  /** 1ページに表示する行数 */
  perPage: number = Number(Setting.otherOffice.home.perPage);
  /** 1ページに表示する行数の選択項目 */
  pageOptions: number[] = Setting.otherOffice.home.pageOptions;

  @Watch("perPage")
  changePerPage(perPage: number): void {
    this.setCookie(perPage);
    return;
  }

  private setCookie(perPage: number): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `other-office-home-per-page=${perPage}; max-age=${saveSecond};`;
    return;
  }

  get _otherOfficeTopPageFunction(): boolean {
    return userStore.loginUser.permissions.functions.otherOfficeTopPageFunction;
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  /** 都道府県選択肢 */
  get _prefectureOptions(): Array<{ value: string; text: string }> {
    if (!regionsStore) {
      return [];
    }

    const options: Array<{ value: string; text: string }> = [];
    options.push({ value: "", text: "全国" });
    for (const region of regionsStore.regions) {
      options.push({ value: region.prefecture.prefectureCode, text: region.prefecture.name });
    }

    return options;
  }

  /** 施設種別選択肢 */
  get _facilityCategoryOptions(): Array<{ value: "" | FacilityCategory; text: string }> {
    return [
      { value: "", text: "全て" },
      { value: FacilityCategory.KAIGO_YUURYOU, text: "介護付有料老人ホーム" },
      { value: FacilityCategory.JYUUTAKU_YUURYOU, text: "住宅型有料老人ホーム" },
      { value: FacilityCategory.SERVICE_JYUUTAKU, text: "サービス付き高齢者向け住宅" },
      { value: FacilityCategory.CONDOMINIUMS, text: "シニア向け分譲マンション" },
      { value: FacilityCategory.GROUP_HOME, text: "グループホーム" },
      { value: FacilityCategory.CARE_HOUSE, text: "ケアハウス" },
      { value: FacilityCategory.TOKUYO, text: "特別養護老人ホーム（特養）" },
      { value: FacilityCategory.KAIGO_HOKEN, text: "介護老人保健施設（老健）" },
      { value: FacilityCategory.MEDICAL_CENTER, text: "介護医療院" },
      { value: FacilityCategory.OTHER, text: "その他" }
    ];
  }

  /**
   * ### 都道府県の変更を監視する
   * 市区町村のチェックをリセットする
   */
  @Watch("filter.prefecture")
  onPrefectureChanged(): void {
    this.filter.municipalities = {};
  }

  /** 選択されている都道府県の市区町村 */
  get _municipalities(): Array<RegionMaster> {
    for (const region of regionsStore.regions) {
      if (region.prefecture.prefectureCode == this.filter.prefecture) {
        return region.municipalities;
      }
    }
    return [];
  }

  /**
   * vue lifecycle mounted
   */
  async mounted(): Promise<void> {
    const fields: Array<OtherOfficeFacilitiesTableField> = this.createFields();
    this.fields = fields;

    const perPage: number | null = this.loadCookie();
    this.perPage = perPage ? perPage : Number(Setting.otherOffice.home.perPage);

    await this.createView();

    return;
  }

  private createFields(): Array<OtherOfficeFacilitiesTableField> {
    const fields: Array<OtherOfficeFacilitiesTableField> = [];
    fields.push({ key: "name", label: "事業所名", sortable: false, sortDirection: "desc", class: "name" });
    fields.push({ key: "reason", label: "地域", sortable: false, sortDirection: "desc", class: "reason" });
    fields.push({ key: "type", label: "施設種別", sortable: false, sortDirection: "desc", class: "type" });
    fields.push({ key: "tel", label: "電話番号", sortable: false, sortDirection: "desc", class: "tel" });
    fields.push({ key: "hpUrl", label: "ホームページ", sortable: false, sortDirection: "desc", class: "hp-url" });
    fields.push({ key: "detail", label: "詳細", sortable: false, sortDirection: "desc", class: "detail text-center" });
    return fields;
  }

  private loadCookie(): number | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているのでisNaN()でチェックが必要
      const perPage: number = Number(cookieMap["other-office-home-per-page"]);

      return isNaN(perPage) ? null : perPage;
    }

    return null;
  }

  private async createView(): Promise<void> {
    this.isLoading = true;

    const connections: Array<OtherOfficeConnectionGetModel> = await this.getOtherOfficeConnections();
    const items: Array<OtherOfficeFacilitiesTableItem> = this.createItems(connections);
    this.items = items;
    this.rows = items.length;

    this.isLoading = false;
    return;
  }

  private async getOtherOfficeConnections(): Promise<Array<OtherOfficeConnectionGetModel>> {
    const response: Array<OtherOfficeConnectionGetModel> = await this.otherOfficeConnectionsService.gets(userStore);
    return response;
  }

  private createItems(connections: Array<OtherOfficeConnectionGetModel>): Array<OtherOfficeFacilitiesTableItem> {
    const items: Array<OtherOfficeFacilitiesTableItem> = connections.filter((connection) => {
      return connection.registerd && connection.facility;
    });
    return items;
  }

  onGotoList(): void {
    this.$router.push(PcUrl.OtherOfficeConnectionList);
    return;
  }

  onInvitation(): void {
    this.showInputInvitationModal = true;
    return;
  }

  inputedInvitation(invitationOtherOfficeConnection: { mailaddress: string; officeName: string; staffName: string }): void {
    this.invitationOtherOfficeConnection = invitationOtherOfficeConnection;
    this.showConfirmInvitationModal = true;
    return;
  }

  async sendInvitation(): Promise<void> {
    this.showInputInvitationModal = false;
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const requestBody: OtherOfficeConnectionMailPostModel = this.createSendMailRequestBody(this.invitationOtherOfficeConnection, SenderType.NEW);
    const result: OtherOfficeConnectionGetModel = await this.otherOfficeConnectionsService.sendMail(userStore, requestBody);

    // 送信した内容を一覧に追加する
    this.items.push(result);
    this.items = this.sortItems(this.items);

    this.isBusy = false;
    this.showSendInvitationSuccessModal = true;
    return;
  }

  private createSendMailRequestBody(
    invitationOtherOfficeConnection: { mailaddress: string; officeName: string; staffName: string },
    sendType: SenderType
  ): OtherOfficeConnectionMailPostModel {
    return {
      sendType: sendType,
      mailaddress: invitationOtherOfficeConnection.mailaddress,
      officeName: invitationOtherOfficeConnection.officeName,
      staffName: invitationOtherOfficeConnection.staffName
    };
  }

  /**
   * ### ソート
   *
   * - 未登録を先にする
   * - 未登録同士の場合、最終招待送信日時の昇順で並べる
   * - 登録済同士の場合、最終招待送信日時の昇順で並べる
   */
  private sortItems(items: Array<OtherOfficeFacilitiesTableItem>): Array<OtherOfficeFacilitiesTableItem> {
    const sortedItems: Array<OtherOfficeFacilitiesTableItem> = items.concat().sort((a, b) => {
      // 未登録同士の場合、最終招待送信日時の昇順で並べる
      if (a.registerd === false && b.registerd === false) {
        if (a.latestSendDatetime < b.latestSendDatetime) {
          return -1;
        }
        if (b.latestSendDatetime < a.latestSendDatetime) {
          return 1;
        }
      }
      // 未登録は無条件で先に並べる
      if (a.registerd === false) {
        return -1;
      }
      if (b.registerd === false) {
        return 1;
      }
      // 最終招待送信日時の昇順で並べる
      if (a.latestSendDatetime < b.latestSendDatetime) {
        return -1;
      }
      if (b.latestSendDatetime < a.latestSendDatetime) {
        return 1;
      }
      return 0;
    });
    return sortedItems;
  }

  /**
   * ### 詳細ボタン押下イベント
   */
  onDetail(item: OtherOfficeFacilitiesTableItem): void {
    this.$router.push({ name: PcUrl.OtherOfficeFacilityDetail, params: { id: `${item.facility.id}` } });
    return;
  }

  /**
   * ### 入所申し込みボタン押下イベント
   *
   * - 入所募集ページを別タブで表示する
   */
  async onApplication(item: OtherOfficeFacilitiesTableItem): Promise<void> {
    const url: string = await this.geWaiterRecruitmentUrl(item.facility.id);
    window.open(url, "_blank");
    return;
  }

  async geWaiterRecruitmentUrl(targetFacilityId: number): Promise<string> {
    const response: string = await this.waiterRecruitmentsService.geWaiterRecruitmentUrl(userStore, { targetFacilityId: targetFacilityId });
    return response;
  }

  selectPerPage(perPage: number): void {
    this.perPage = perPage;
    this.currentPage = 1;
    return;
  }

  selectPage(page: number): void {
    this.currentPage = page;
    return;
  }
}
</script>

<style lang="scss" scoped>
#home-for-other-office-service {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box {
    .box-header {
      .note {
        width: calc(100% - 210px);
      }

      .buttons {
        min-width: 200px;
      }
    }
  }

  .advanced-filters {
    .basic-filters {
      border-radius: 3px;
      border: solid 1px rgba(228, 228, 228, 1);

      .basic-filter {
        background-color: #f5f5f5;
        border-radius: 3px;
        padding: 0.4rem;

        .table-option-text {
          font-size: 14px;
        }

        // 空床有り施設のみの日付入力
        .only-blank-room-date {
          width: 170px;
          min-width: 170px;
          background-color: #fff;
          cursor: pointer;
        }
      }
    }
  }

  .other-office-base-info {
    margin-left: -3px;
    margin-right: -3px;
    .home-box {
      padding-left: 3px;
      padding-right: 3px;
    }
  }
}
</style>
